module.exports = __webpack_public_path__ + "media/white-label/visual-style-8d3bf0ae.png";